import React, { useState } from "react";
import FieldDropdown from "../../../components/common/InputField/FieldDropdown";
import { ACCOUNT_POPUP_MUTED_PANEL } from "../../../components/BusinessDashboard/accountPopupFields";
import {
  AdminDetailFieldLabel,
  AdminSupportingText,
  AdminHeaderAction,
  adminWizardDropdownClasses,
  adminWizardTextareaClasses,
} from "../../AdminDashboard/shared/adminUx";
import {
  CUSTOMER_WIZARD_CONTENT_WIDE_CLASS,
  CUSTOMER_FORM_ACTION_ROW_END_CLASS,
} from "../shared/customerLayoutSpec";

const Deactivation = () => {
  const [selectedReason, setSelectedReason] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [confirmed, setConfirmed] = useState(false);

  const reasonOptions = [
    { label: "I no longer require services at the moment.", value: "I no longer require services at the moment." },
    { label: "I've found the services I needed through a different source.", value: "I've found the services I needed through a different source." },
    { label: "The services on the platform did not meet my expectations.", value: "The services on the platform did not meet my expectations." },
    { label: "I experienced difficulties navigating the platform.", value: "I experienced difficulties navigating the platform." },
    { label: "I have concerns about my privacy and data.", value: "I have concerns about my privacy and data." },
    { label: "Others", value: "Others" },
  ];

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div className={`${CUSTOMER_WIZARD_CONTENT_WIDE_CLASS} space-y-5`}>
        <div className="space-y-1">
          <AdminDetailFieldLabel>Reason for deactivation</AdminDetailFieldLabel>
          <FieldDropdown
            surface="muted"
            fullWidth
            value={selectedReason ?? ""}
            onChange={(e) => setSelectedReason(e.value)}
            options={reasonOptions}
            placeholder="Please select your reason for leaving"
            className={adminWizardDropdownClasses(false, true)}
            panelClassName={ACCOUNT_POPUP_MUTED_PANEL}
            showClear={false}
            appendTo={null}
          />
        </div>
        <div className="space-y-1">
          <AdminDetailFieldLabel htmlFor="deactivation-feedback-page">
            Additional feedback
          </AdminDetailFieldLabel>
          <textarea
            id="deactivation-feedback-page"
            placeholder="Your insights are invaluable to us. If you have any additional comments about your experience, encountered difficulties, suggestions for improvement, or compliments, we'd love to hear them."
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            rows={4}
            className={`${adminWizardTextareaClasses(false)} lg:bg-pastalblue`}
            style={{ resize: "none" }}
          />
        </div>
        <div>
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="checkbox"
              id="deactivation-confirm-page"
              checked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
              className="size-4 mt-0.5 rounded border-mediumgray text-primaryblue focus:ring-primaryblue"
            />
            <div>
              <AdminSupportingText className="text-offblack block font-medium">
                Account deactivation confirmation
              </AdminSupportingText>
              <AdminSupportingText className="text-mediumgray mt-2 block">
                Confirm your request to deactivate your customer account. This will terminate all
                ongoing interactions and remove access to any preferences or saved data on our
                platform.
              </AdminSupportingText>
            </div>
          </label>
        </div>
      </div>
      <div className={`${CUSTOMER_WIZARD_CONTENT_WIDE_CLASS} ${CUSTOMER_FORM_ACTION_ROW_END_CLASS}`}>
        <AdminHeaderAction
          type="button"
          className="!bg-alertred hover:opacity-90"
          disabled={!confirmed}
        >
          Deactivate
        </AdminHeaderAction>
      </div>
    </form>
  );
};

export default Deactivation;
